import React, { useState, useEffect, useRef } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje } from "../mensajes";
import axios from "axios";
import moment from "moment";
import { ModalInspecciones } from "./modalinspecciones";
import { validarFechas } from "../../util/varios";

const Inspecciones = () => {
  const op = require("../../../public/modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const txtBuscador = useRef();
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          NRO (GUIA / N-ENTREGA)
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-signature">
          {" "}
          MINA
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-signature">
          {" "}
          INSPECCIONES
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code-branch">
          {" "}
          USUARIO APP
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code-branch">
          {" "}
          FECHA / HORA
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [fechas, setFechas] = useState({
    desde: moment(fechaSistema).format("YYYY-MM-DD"),
    hasta: moment(fechaSistema).format("YYYY-MM-DD")
  });
  const [inspeccion, setInspeccion] = useState();
  const [operacion, setOperacion] = useState(1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if ((x.idguia !== null ? x.idguia.includes(target.value) : x.ne.includes(target.value)) ||
              x.idinspeccion.includes(target.value) ||
              x.mina.toLowerCase().includes(target.value.toLowerCase()) ||
              x.usuarioapp.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarRegistros = (desde, hasta) => {
    setActivate(true);

    const campos = `c.idinspeccion, c.hora, c.idguia, c.ne,
(select inspeccion from guiadetalle where idguiadetalle=c.idguia limit 1) as cantidad,
(select nombre from agente where idagente=c.idmina limit 1) as mina,
(select UPPER(login) from usuarioapp where idusuario=c.idusuarioapp limit 1) as usuarioapp,
UPPER(c.chofer) as chofer,
c.fecha`;
    const nomtab = `inspecciones as c  where  c.fecha BETWEEN '${desde}' AND '${hasta}'`;
    const orden = "c.idinspeccion";

    const endpoint = `${op.conexion}/api/inspeccion/consultar?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          txtBuscador.current.focus();
        }
      })
      .catch(function (error) {
        console.log(error);

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarcontrolguia = (id) => {
    setActivate(true);
    const campos = "*";
    const nomtab = "inspecciones";
    const nomid = "idinspeccion";

    const endpoint = `${op.conexion}/api/inspeccion/consultarid?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setInspeccion(response.data);
            setMostrar2(true);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const gestionarExpendedor = (ope, id) => {
    setOperacion(ope);
    if (ope === 1) {
      setMostrar2(true);
    } else {
      seleccionarcontrolguia(id);
    }
  };

  const onChange = (event) => {
    if (event.target.value !== "") {
      setRecords([]);
      setFechas({...fechas, [event.target.name]: event.target.value});
      if (event.target.name==="desde") {
        if (validarFechas(event.target.value, fechas.hasta)) {
          SeleccionarRegistros(event.target.value, fechas.hasta);     
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "la fecha desde no puede ser mayor a la fecha hasta.",
            icono: "informacion",
          });
        }
      }

      if (event.target.name==="hasta") {
        if (validarFechas(fechas.desde, event.target.value)) {
          SeleccionarRegistros(fechas.desde, event.target.value);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "la fecha desde no puede ser mayor a la fecha hasta.",
            icono: "informacion",
          });
        }
      }      
    }
  };

  const onHide = (refress = false) => {
    setMostrar2(false);
    if (refress) {
      SeleccionarRegistros(fechas.desde, fechas.hasta);
    }
  };

  useEffect(() => {
    SeleccionarRegistros(fechas.desde, fechas.hasta);
  }, []);

  return (
    <div
      className="p-0 m-0"
      style={{ backgroundColor: "#", height: "100%", width: "100%" }}
    >
      <div className="row col-md-12 py-5">
        <div className="row  col-md-12 p-2 mt-4">
          <div className="col-md-6 d-flex justify-content-between">
            <input
              type="text"
              className="form-control form-control-sm rounded-pill"
              ref={txtBuscador}
              onChange={handleSearch}
              placeholder="Buscar"
            />

            {/*             <div className="col-3 d-flex justify-content-end">
              <button
                onClick={() => gestionarExpendedor(1, "")}
                style={{ marginBottom: "5px" }}
                className={"btn btn-sm btn-primary rounded-circle"
                }
              >
                <i className="fas fa-plus"></i>{" "}
              </button>
            </div> */}
          </div>
          <div className="input-group input-group-sm mb-3 col-md-3">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Desde
            </span>
            <input
              type="date"
              name="desde"
              onChange={onChange}
              defaultValue={moment(fechaSistema).format("YYYY-MM-DD")}
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
          <div className="input-group input-group-sm mb-3 col-md-3">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Hasta
            </span>
            <input
              type="date"
              name="hasta"
              onChange={onChange}
              defaultValue={moment(fechaSistema).format("YYYY-MM-DD")}
              className="form-control"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow key={index} style={{ padding: "0" }}>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.idguia}{item.ne}
                    </TableCell>
                    <TableCell style={{ textAlign: "start" }}>
                      {item.mina}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.cantidad}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.usuarioapp}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {moment(item.fecha).format("DD-MM-YYYY")} {item.hora}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      <button
                        onClick={() =>
                          gestionarExpendedor(4, item.idinspeccion)
                        }
                        className={"btn btn-sm  btn-info rounded-circle ml-2"}
                      >
                        <i className="fas fa-eye"></i>{" "}
                      </button>
                      {/*                       <button
                        onClick={() => gestionarExpendedor(2, item.idinspeccion)}
                        className={"btn btn-sm  btn-warning rounded-circle ml-2"
                        }
                      >
                        <i className="fa fa-edit"></i>{" "}
                      </button>
                      <button
                        onClick={() => gestionarExpendedor(3, item.idinspeccion)}
                        className={"btn btn-sm  btn-danger rounded-circle ml-2"
                        }
                      >
                        <i className="fa fa-trash"></i>{" "}
                      </button> */}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>

        <ModalInspecciones
          show={mostrar2}
          operacion={operacion}
          inspeccion={inspeccion}
          onHide={onHide}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
      </div>
      <Dimmer active={activate} />
    </div>
  );
};
export default Inspecciones;



// WEBPACK FOOTER //
// ./src/components/fiscales/inspecciones.js